//import { firestore } from "../Firebase";
// import { doc, getDoc } from "firebase/firestore";
import type { DocumentReference } from "firebase/firestore";
import { ContractType } from "../store/actions/accessCodeActions";
import { getAuth } from "firebase/auth";
const SERVER_URL = "https://us-central1-elisyanwealth.cloudfunctions.net/";
const BASE_URL =
  "http://127.0.0.1:5001/elisyanwealth/us-central1/";

// getContractByAccessCodeId is wired to the v2 endpoint
// (functions/v2/endpoints/accessCodeEndpoints.ts → getContractByAccessCodeId_v2),
// which reads accessCodes_v2 / contracts_v2. Pointed at BASE_URL (functions
// emulator) for pre-deploy testing — set GET_CONTRACT_V2_DEPLOYED = true
// after `firebase deploy --only functions:getContractByAccessCodeId_v2`.
const GET_CONTRACT_V2_DEPLOYED = true;
const GET_CONTRACT_V2_URL = GET_CONTRACT_V2_DEPLOYED ? SERVER_URL : BASE_URL;

interface ContractDataType {
    owner: DocumentReference;  // Reference to a business document
    useLimit: number;
    expire_at?: string;
    licence_count: number;
    reference: string;
  }
  
// export async function getContractByAccessCodeId(accessCodeId: string): Promise<ContractType | undefined> {
//     try {
//       // Step 1: Fetch the access code document
//       const accessCodeRef = doc(firestore, `access_codes/${accessCodeId}`);
//       const accessCodeSnap = await getDoc(accessCodeRef);
  
//       if (!accessCodeSnap.exists()) {
//         //console.log("Access code not found.");
//         return undefined;
//       }
  
//       // Step 2: Get the contract reference from the access code document
//       const accessCodeData = accessCodeSnap.data();
//       const contractRef = accessCodeData?.contract_ref;
  
//       if (!contractRef) {
//        // console.log("No contract reference found in access code.");
//         return undefined;
//       }
  
//       // Step 3: Fetch the contract document
//       const contractSnap = await getDoc(contractRef);
//       if (!contractSnap.exists()) {
//         //console.log("Contract not found.");
//         return undefined;
//       }
  
//       // Specify the contract data structure with ContractDataType
//       const contractData = contractSnap.data() as ContractDataType;
  
//       // Step 4: Get the business_client ID from contractData.owner
//       let business_client: string | undefined = undefined;
//       if (contractData?.owner) {
//         const ownerSnap = await getDoc(contractData.owner);
//         if (ownerSnap.exists()) {
//           business_client = ownerSnap.id;
//         }
//       }
  
//       // Step 5: Format the contract data according to ContractType
//       const contract: ContractType = {
//         business_client,
//         contract_ref: contractData.reference,
//         useLimit: contractData.useLimit ?? 0,
//         expire_at: contractData.expire_at ? new Date(contractData.expire_at) : undefined,
//         licence_count: contractData.licence_count ?? 0,
//         id: contractSnap.id,
//       };
  
//       //console.log("Contract data:", contract);
//       return contract;
//     } catch (error) {
//       console.error("Error retrieving contract by access code ID:", error);
//       return undefined;
//     }
//   }

export async function getContractByAccessCodeId(
  accessCodeId: string,
): Promise<ContractType | undefined> {
  try {
    const user = getAuth().currentUser
    if (!user) {
      console.error('No authenticated user')
      return undefined
    }
    const token = await user.getIdToken()

    const res = await fetch(
      `${GET_CONTRACT_V2_URL}getContractByAccessCodeId_v2`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ accessCodeId }),
      },
    )

    const { data } = await res.json()

    if (!res.ok || !data) return undefined

    return {
      id: data.id,
      business_client: data.business_client,
      contract_ref: data.contract_ref,
      useLimit: data.useLimit,
      expire_at: data.expire_at ? new Date(data.expire_at) : undefined,
      licence_count: data.licence_count,
    } as ContractType
  } catch (error) {
    console.error('Error retrieving contract by access code ID:', error)
    return undefined
  }
}